var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mb-2 w-100",attrs:{"link":"","href":_vm.baseUrl + '/auth/auth0',"color":"primary"}},[_c('span',{staticClass:"fab fa-email"}),_vm._v(" "+_vm._s(_vm.tL('email')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }